<template>
	<div class="sk_eye_android_user_help">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">使用说明</h1>
		<h3 class="doc_main_h3">
			概述
		</h3>
		<p class="doc_main_p">
			该文档将详细说明如何在 Windows 平台上快速集成该 SDK，并通过调用 SDK 接口使用 SKEye 图像识别服务。 
		</p>
		<h3 class="doc_main_h3">
			系统需求
		</h3>
		<p class="doc_main_p">
			Windows 7 及以上版本系统 
		</p>
		<h3 class="doc_main_h3">
			使用步骤
		</h3>
		<p class="doc_main_p">
			支持使用 Visual Studio 2013 进行集成使用，在新建工程后，将 lib、dll、.h 文件拷贝至对应目录，具体使用可参考 Demo 工程。
		</p>
		<h3 class="doc_main_h3">
			Demo说明
		</h3>
		<p class="doc_main_p">
			案例展示如何调用 SKEyeSDK 接口，图像识别结果会打印到 win32 控制台上，用户只需要将结果数据拷贝到自己申请好的内存中(不需要释放结果数据空间)。 
		</p>
		<h3 class="doc_main_h3">
			关键参数说明
		</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">ApiKey：char 数组类型，指当前 APP 所申请的SKEye 的 API_KEY 
ApiSecret：char 数组类型，指当前 APP 所申请的 SKEye 的 API_SECRET 
ServiceName：char 数组类型，指 SKEye 识别服务名称  
ImageId：int 类型，图片 id(方便确认请求顺序和返回顺序是否一致) 
ImageUrl：char 数组类型，指图片的网络 url/本地路径
ImageData:unsigned char *类型，指 BGR、倒立、无行对齐,图片数据
ImageWidth: unsigned int 类型，指图片的宽度 
ImageHeight: unsigned int 类型，指图片的高度 
CallBackImageResultFunction：void CallBackImageResult * 类型，指图片结果回调</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['物体识别','SKEye-Windows','使用说明'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../less/index.less';
	.sk_eye_android_user_help{
		.ios_1_png{
			display: block;
			width: 200px;
			margin:20px auto;
		}
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skeyewindows/SKEyeUserHelp.vue